export const firebaseConfig = {
  apiKey: 'AIzaSyCPqRTTxkXKuDYEAL0PSriJoEreaus_jNE',
  authDomain: 'product-tools.firebaseapp.com',
  databaseURL: 'https://product-tools.firebaseio.com',
  storageBucket: 'product-tools.appspot.com',
  messagingSenderId: '276208416304',
};

export default firebaseConfig;



// WEBPACK FOOTER //
// ./src/constants/app.js